import http from "../../http/requests/report/index.js";

export default {
  fetchReport(context, reportID) {
    return new Promise((resolve, reject) => {
      http
        .fetchReport(reportID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA SINGLE REPORT");
          console.log(error);
          reject(error);
        });
    });
  },
  fetchReports({ commit }) {
    return new Promise((resolve, reject) => {
      http
        .fetchReports()
        .then(response => {
          commit("SET_REPORTS", response.data);
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA REPORTS");
          console.log(error);
          reject(error);
        });
    });
  },
  addReport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      http
        .addReport(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA ADD REPORT");
          console.log(error);
          reject(error);
        });
    });
  },
  addFileToReport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      http
        .addFileToReport(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA ADD FILE TO REPORT");
          console.log(error);
          reject(error);
        });
    });
  },
  editReport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      http
        .editReport(payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA EDIT REPORT");
          console.log(error);
          reject(error);
        });
    });
  },
  deleteReport(context, reportID) {
    return new Promise((resolve, reject) => {
      http
        .deleteReport(reportID)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log("NAPAKA DELETE REPORT");
          console.log(error);
          reject(error);
        });
    });
  }
};
